import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = ["id", "name", "value"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'RadioInput',
    props: /*@__PURE__*/ _mergeModels({
        dataField: {},
        placeHolder: {},
        items: {}
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const modelValue = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "col-l-4 col-m-4 col-3 gdwrapper",
                    key: index
                }, [
                    _createElementVNode("label", {
                        class: "col-l-3 col-m-4 col-5",
                        for: props.dataField + '-' + item
                    }, _toDisplayString(item.name), 9, _hoisted_1),
                    _withDirectives((_openBlock(), _createElementBlock("input", {
                        class: "col-l-9 col-m-8 col-7",
                        type: "radio",
                        id: props.dataField + '-' + item.name,
                        name: props.dataField,
                        key: index,
                        value: item.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValue).value = $event))
                    }, null, 8, _hoisted_2)), [
                        [_vModelRadio, modelValue.value]
                    ])
                ]));
            }), 128));
        };
    }
});
